import React from 'react';
import { ToggleSwitch } from '@boatsetter-backup/js-component-lib';
import styled from 'styled-components';
import { Trans } from '@lingui/react';

const ShowMapToggle = ({ showMap, setShowMap, setForceShowMapByButton, forceShowMapByButton, togleShowMap }) => {
  const toggleMap = () => {
    // setShowMap(!showMap);
    // setForceShowMapByButton(!forceShowMapByButton);
    togleShowMap();
  };

  return (
    <Wrapper>
      <ToggleSwitch
        isActive={forceShowMapByButton}
        onChange={toggleMap}
        onLabel={<Trans id="mapToggle.hideMap" />}
        offLabel={<Trans id="mapToggle.showMap" />}
      />
    </Wrapper>
  );
};

export default ShowMapToggle;

const Wrapper = styled.div`
  margin-left: auto;
  cursor: pointer;
`;
